import { useEffect } from "react";

import { AppUI, selectUIMode } from "@/features/app/appSlice";

import { useAppSelector } from ".";

export const useScreenReadersFocus = () => {
  const uiMode = useAppSelector(selectUIMode);

  useEffect(() => {
    const timeout = setTimeout(() => {
      let el: HTMLElement | null = null;

      switch (uiMode) {
        case AppUI.explore:
          el = document.getElementById("center-user");
          break;
        case AppUI.directions:
          el = document.getElementById("center-user");
          break;
        case AppUI.navigation:
          el = document.getElementById("navigation-panel__indications-message");
          break;
        default:
          break;
      }
      el?.focus();
    }, 250);

    return () => clearTimeout(timeout);
  }, [uiMode]);
};
